<template>
    <form @submit.prevent="createOrUpdateUpgrade()">
        <h6 class="heading-small text-muted mb-4">ข้อมูลร้าน</h6>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ชื่อร้าน/ชื่อสาขา <span class="text-red">(ภาษาไทย)</span>
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ชื่อร้าน/ชื่อสาขา (ภาษาไทย)"
                        :class="{ 'is-invalid': submittEdit && $v.brance.branceName.$error }"
                        v-model="brance.branceName"
                    />
                    <!-- vuelidate -->
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.brance.branceName.minLength"
                    >กรุณากรอก"ชื่อร้าน/ชื่อสาขา"อย่างน้อย {{$v.brance.branceName.$params.minLength.min}} ตัวอักษร</label>
                    <label
                        v-if="submittEdit && !$v.brance.branceName.required"
                        class="invalid-feedback"
                    >กรุณากรอกชื่อร้าน/ชื่อสาขา</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ชื่อร้าน/ชื่อสาขา <span class="text-red">(ภาษาอังกฤษ)</span>
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ชื่อร้าน/ชื่อสาขา (ภาษาอังกฤษ)"
                        :class="{ 'is-invalid': submittEdit && $v.brance.branceNameEng.$error }"
                        v-model="brance.branceNameEng"
                    />
                    <!-- vuelidate -->
                    <label
                        v-if="submittEdit && !$v.brance.branceNameEng.required"
                        class="invalid-feedback"
                    >กรุณากรอกชื่อร้าน/ชื่อสาขา</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        ชื่อบริษัท (ถ้ามี กรณีเป็นนิติบุคคล)
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ชื่อบริษัท (ถ้ามี กรณีเป็นนิติบุคคล)"
                        v-model="brance.companyName"
                    />
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> เบอร์โทรศัพท์ร้านค้า
                    </label>
                    <input
                        type="number"
                        class="form-control hide-arrow"
                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                        placeholder="เบอร์โทรศัพท์ร้านค้า"
                        :class="{ 'is-invalid': submittEdit && $v.brance.branceTel.$error }"
                        v-model="brance.branceTel"
                    />
                    <!-- vuelidate -->
                    <label
                        v-if="submittEdit && !$v.brance.branceTel.required"
                        class="invalid-feedback"
                    >กรุณากรอกเบอร์โทรศัพท์ร้านค้า</label>
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.brance.branceTel.minLength"
                    >กรุณากรอก"เบอร์โทรศัพท์ร้านค้า"อย่างน้อย {{$v.brance.branceTel.$params.minLength.min}}ตัวเลข</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        รหัสร้านค้า
                    </label>
                    <input
                        readonly
                        type="text"
                        class="form-control"
                        placeholder="รหัสร้านค้า"
                        v-model="brance.shopCode"
                    />
                </div>
            </div>
            <div class="col-lg-6" v-if="!this.$USER_LOGIN.get().isUnderByShippop">
                <div class="form-group">
                    <label>
                        รหัสตัวแทน
                    </label>
                    <input
                        readonly
                        type="text"
                        class="form-control"
                        placeholder="รหัสร้านค้า"
                        v-model="brance.dealerId"
                    />
                </div>
            </div>
            <div class="col-lg-12" v-if="this.$USER_LOGIN.get().isShippop">
                <div class="form-group">
                    <label>
                        Ref Member Id (ดูจากรหัส Member บนระบบต่างประเทศ ตัด B-XXXXXX, C-XXXXXX เอามาเฉพาะตัวเลขไม่ต้องมี 0 นำหน้านะ)
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="223456"
                        v-model="brance.ref_member_id"
                    />
                </div>
            </div>
            <div class="col-lg-6" v-if="this.$USER_LOGIN.get().isShippop">
                <div class="form-group">
                    <label>
                        Market Id
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Market Id"
                        v-model="brance.marketId"
                    />
                </div>
            </div>
            <div class="col-lg-6" v-if="$USER_LOGIN.get().isAdmin && this.$THEME.manageVision.brancePackage">
                <div class="form-group">
                    <label>
                        แพ็กเกจ
                    </label>
                    <input
                        disabled
                        type="text"
                        class="form-control"
                        placeholder="แพ็กเกจ"
                        v-model="brance.package"
                    />
                </div>
            </div>
            <div class="col-lg-6" v-if="$USER_LOGIN.get().isAdmin">
                <div class="form-group">
                    <label>
                        วันเซ็นสัญญา
                    </label>
                    <input
                        disabled
                        type="date"
                        class="form-control"
                        placeholder="วันเซ็นสัญญา"
                        v-model="brance.contractDate"
                    />
                </div>
            </div>
            <div class="col-lg-6" v-if="$USER_LOGIN.get().isAdmin">
                <div class="form-group">
                    <label>
                        เงื่อนไขพื้นที่ให้บริการ 
                        <!-- <i class="fas fa-exclamation-circle fa-xs text-muted" style="cursor: pointer;" @click="$emit('openModalConditionArea')"></i> -->
                    </label>
                    <input
                        disabled
                        type="text"
                        class="form-control"
                        placeholder="เงื่อนไขพื้นที่ให้บริการ"
                        :value="serviceAreaBrance(brance.serviceAreaCondition)"
                    />
                </div>
            </div>
            <div class="col-lg-6" v-if="$USER_LOGIN.get().isSuperadmin || $USER_LOGIN.get().isShippop">
                <div class="form-group">
                    <label><span class="text-danger">*</span> กำหนดจำนวนผู้ใช้ ({{brance.countUser}} /15 คน)</label>
                    <input
                        type="text"
                        class="form-control"
                        :placeholder="`กำหนดจำนวนผู้ใช้ (${brance.countUser} /15 คน)`"
                        v-model="brance.member"
                    />
                </div>
            </div>
            <div class="col-lg-6" 
                v-if="this.$THEME.serviceName.lazada && additional_service.DROPOFF.LZDS.status !== 'false'"
                v-show="enableAdditionalService('LZDS')"
            >
                <div class="form-group">
                    <label><span class="text-danger">*</span> ชื่อจุดบริการ LAZADA Drop off</label>
                    <input
                        :readonly="!$USER_LOGIN.get().isShippop"
                        type="text"
                        class="form-control"
                        placeholder="ชื่อจุดบริการ LAZADA Drop off"
                        v-model="brance.lazadaDropoff"
                        :class="{ 'is-invalid' : lazadaValidation.lazadaDropoff }"
                    />
                </div>
            </div>
            <div class="col-lg-6" 
                v-if="this.$THEME.serviceName.lazada && this.$USER_LOGIN.get().isShippop && additional_service.DROPOFF.LZDS.status !== 'false'"
                v-show="enableAdditionalService('LZDS')"
            >
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span>  Lazada Cage No.
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Lazada Cage No."
                        v-model="brance.lazada_cage_no"
                        :class="{ 'is-invalid' : lazadaValidation.lazada_cage_no }"
                    />
                </div>
            </div>
            <div class="col-lg-6" 
            v-if="this.$THEME.serviceName.lazada && this.$USER_LOGIN.get().isShippop && additional_service.DROPOFF.LZDS.status !== 'false'"
            v-show="enableAdditionalService('LZDS')">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span>  Lazada Station Code
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Lazada Station Code"
                        v-model="brance.lazada_station_code"
                        :class="{ 'is-invalid' : lazadaValidation.lazada_station_code }"
                    />
                </div>
            </div>
            <div class="col-lg-6" v-if="this.$THEME.serviceName.dhl">
                <div class="form-group">
                    <label><span class="text-danger">*</span> ชื่อจุดบริการ DHL Drop off</label>
                    <input
                        :readonly="!$USER_LOGIN.get().isShippop"
                        type="text"
                        class="form-control"
                        placeholder="ชื่อจุดบริการ DHL Drop off"
                        v-model="brance.dhlDropoff"
                    />
                </div>
            </div>
            <div class="col-lg-6" v-if="this.$THEME.serviceName.shippop">
                <div class="form-group">
                    <label><span class="text-danger">*</span> ชื่อจุดบริการ SHIPPOP Drop off</label>
                    <input
                        :readonly="!$USER_LOGIN.get().isShippop"
                        type="text"
                        class="form-control"
                        placeholder="ชื่อจุดบริการ SHIPPOP Drop off"
                        v-model="brance.shippopDropoff"
                    />
                </div>
            </div>
            <div class="col-lg-6" v-if="this.$THEME.serviceName.shopee">
                <div class="form-group">
                    <label><span class="text-danger">*</span> ชื่อจุดบริการ Shopee Express Drop off</label>
                    <input
                        :readonly="!$USER_LOGIN.get().isShippop"
                        type="text"
                        class="form-control"
                        placeholder="ชื่อจุดบริการ Shopee Express Drop off"
                        v-model="brance.shopeeDropoff"
                    />
                </div>
            </div>
            <div class="col-lg-6" v-if="this.$THEME.serviceName.doubleA">
                <div class="form-group">
                    <label><span class="text-danger">*</span> ชื่อจุดบริการ Double A FastPrint</label>
                    <input
                        :readonly="!$USER_LOGIN.get().isShippop"
                        type="text"
                        class="form-control"
                        placeholder="ชื่อจุดบริการ Double A FastPrint"
                        v-model="brance.doubleAFastPrint"
                    />
                </div>
            </div>
            <div class="col-lg-6" 
                v-if="this.$THEME.serviceName.kerry"
                v-show="enableAdditionalService('KERRY_DROPOFF')"
            >
                <div class="form-group">
                    <label><span class="text-danger">*</span> Kerry Branch ID</label>
                    <input
                        :readonly="!$USER_LOGIN.get().isShippop"
                        type="text"
                        class="form-control"
                        placeholder="Kerry Branch ID"
                        v-model="brance.kerryBranchId"
                    />
                </div>
            </div>
            <div class="col-lg-6" 
                v-if="this.$THEME.serviceName.kerry_quick">
                <div class="form-group">
                    <label><span class="text-danger">*</span> Kerry Quick Branch ID</label>
                    <input
                        :readonly="!$USER_LOGIN.get().isShippop"
                        type="text"
                        class="form-control"
                        placeholder="Kerry Quick Branch ID"
                        v-model="brance.kerryQuickBranchId"
                    />
                </div>
            </div>
            <div class="col-lg-6" v-if="this.$THEME.serviceName.kerry_orange">
                <div class="form-group">
                    <label><span class="text-danger">*</span> Kerry Orange Branch ID</label>
                    <input
                        :readonly="!$USER_LOGIN.get().isShippop"
                        type="text"
                        class="form-control"
                        placeholder="Kerry Orange Branch ID"
                        v-model="brance.kerryOrangeBranchId"
                    />
                </div>
            </div>
            <div class="col-lg-6" 
                v-if="this.$THEME.serviceName.flash_dropoff"
                v-show="enableAdditionalService('FLEDS')"
            >
                <div class="form-group">
                    <label><span class="text-danger">*</span> Flash Dropoff Branch ID</label>
                    <input
                        :readonly="!$USER_LOGIN.get().isShippop"
                        type="text"
                        class="form-control"
                        placeholder="Flash Express Branch ID"
                        v-model="brance.flashBranchId"
                        :class="{ 'is-invalid' : flashValidation.flash_branch_id }"
                    />
                </div>
            </div>
            <div class="col-lg-6" 
                v-if="this.$THEME.serviceName.flash_dropoff"
                v-show="enableAdditionalService('FLEDS')"
            >
                <div class="form-group">
                    <label><span class="text-danger">*</span> ชื่อสาขา Flash Dropoff</label>
                    <input
                        :readonly="!$USER_LOGIN.get().isShippop"
                        type="text"
                        class="form-control"
                        placeholder="ชื่อสาขา Flash Dropoff"
                        v-model="brance.flashBranchName"
                        :class="{ 'is-invalid' : flashValidation.flash_branch_name }"
                    />
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ลักษณะธุรกิจหน้าร้านของคุณ
                    </label>
                    <v-select 
                        :class="[ { 'is-invalid bd-danger': submittEdit && $v.brance.natureBusiness.$error } , 'w-100' ]"
                        v-model="brance.natureBusiness" 
                        :options="natureBusiness"
                        placeholder="กรุณาเลือกลักษณะธุรกิจหน้าร้านของคุณ"
                    ></v-select> 
                     <label
                        v-if="submittEdit && !$v.brance.natureBusiness.required"
                        class="invalid-feedback d-block"
                    >กรุณาเลือกลักษณะธุรกิจหน้าร้านของคุณ</label>
                </div>
            </div>
            <div class="col-lg-6" v-if="brance.natureBusiness == 'อื่นๆ'">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> อื่นๆ โปรดระบุ
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="อื่นๆ โปรดระบุ"
                        :class="{ 'is-invalid': submittEdit && $v.brance.natureBusinessOther.$error }"
                        v-model="brance.natureBusinessOther"
                    />
                    <label
                        v-if="submittEdit && !$v.brance.natureBusinessOther.required"
                        class="invalid-feedback d-block">กรุณากรอกรายละเอียด
                    </label> 
                </div>
            </div>
        </div>
        <template v-if="$USER_LOGIN.get().isSuperadmin || $USER_LOGIN.get().isShippop">
            <hr class="my-4" />
            <div class="row pt-4">
                <div class="col-lg-6" v-if="$USER_LOGIN.get().isShippop">
                    <div class="form-group">
                        <label>แพ็กเกจ</label>
                        <b-form-select :options="packageShop" v-model="brance.package_id">
                            <template v-slot:first>
                            <option :value="null || ''" disabled>{{'กรุณาเลือกแพ็กเกจ'}}</option>
                            </template>
                        </b-form-select>
                    </div>
                </div>
                <div class="col-lg-6" v-if="$USER_LOGIN.get().isShippop">
                    <div class="form-group">
                        <label><span class="text-danger">*</span> เงื่อนไขพื้นที่ให้บริการ</label>
                        <b-form-select :options="conditionArea" v-model="brance.serviceAreaCondition">
                            <template v-slot:first>
                            <option :value="null || ''" disabled>{{'กรุณาเลือกเงื่อนไขพื้นที่ให้บริการ'}}</option>
                            </template>
                        </b-form-select>
                    </div>
                </div>
                <div class="col-lg-6" v-if="$USER_LOGIN.get().isShippop">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> วันเซ็นสัญญา
                        </label>
                        <input
                            type="date"
                            class="form-control"
                            placeholder="วันเซ็นสัญญา"
                            v-model="brance.contractDate"
                        />
                    </div>
                </div>
                <div class="col-lg-6" v-if="$USER_LOGIN.get().isShippop">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> วันหมดสัญญา
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="วันหมดสัญญา"
                            v-model="brance.dateExp"
                        />
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                    <label floater>ระบบ COD</label>
                    <b-form-select :options="typeCod" v-model="brance.selectedCod"></b-form-select>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> API KEY
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="API KEY"
                            v-model="brance.apiKey"
                            :readonly="customTheme.useDefaultAPIKey"
                        />
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>วันหมดอายุแพ็กเกจ</label>
                        <b-form-select :options="detailPackage" v-model="brance.selectTrial">
                            <template v-slot:first>
                                <option :value="null" disabled>{{brance.dateExp}}</option>
                            </template>
                        </b-form-select>
                    </div>
                </div>
            </div>
         </template>
        <BranceTax
            ref="branceTax"
            :vatShop="brance.vatShop"
            :submittEdit.sync="submittEdit"
        />
        <hr class="my-4" />
        <div class="row">
            <div class="col-lg-6">
                <h6 class="heading-small text-muted mb-4">ที่อยู่ร้านภาษาไทย</h6>
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> รหัสไปรษณีย์
                    </label>
                    <AutocompletesAddress
                        :queryInput="brance.postcode" 
                        :adsTypes="'postcode'"
                        placeHolder="รหัสไปรษณีย์"
                        :class="{ 'is-invalid': submittEdit && $v.brance.postcode.$error }"
                        @input="brance.postcode = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'brance' )">
                    </AutocompletesAddress>
                    <!-- vuelidate -->
                    <label
                    v-if="submittEdit && !$v.brance.postcode.required"
                    class="invalid-th-address"
                    >กรุณากรอกรหัสไปรษณีย์</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submittEdit && !$v.brance.postcode.minLength"
                    >กรุณากรอก"รหัสไปรษณีย์" {{$v.brance.postcode.$params.minLength.min}} หลัก</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submittEdit && !$v.brance.postcode.maxLength"
                    >กรุณากรอก"รหัสไปรษณีย์" {{$v.brance.postcode.$params.maxLength.max}} หลัก</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submittEdit && !$v.brance.postcode.numeric"
                    >กรุณากรอกเฉพาะตัวเลข</label>
                </div>
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> จังหวัด (ภาษาไทย)
                    </label>
                    <AutocompletesAddress
                        :queryInput="brance.province" 
                        :adsTypes="'province'"
                        placeHolder="จังหวัด (ภาษาไทย)"
                        :class="{ 'is-invalid': submittEdit && $v.brance.province.$error }"
                        @input="brance.province = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'brance' )">
                    </AutocompletesAddress>
                    <label
                        v-if="submittEdit && !$v.brance.province.required"
                        class="invalid-th-address"
                    >กรุณากรอกจังหวัด (ภาษาไทย)</label>
                </div>
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> อำเภอ/เขต (ภาษาไทย)
                    </label>
                    <AutocompletesAddress
                        :queryInput="brance.district" 
                        :adsTypes="'district'"
                        placeHolder="อำเภอ/เขต (ภาษาไทย)"
                        :class="{ 'is-invalid': submittEdit && $v.brance.district.$error }"
                        @input="brance.district = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'brance' )">
                    </AutocompletesAddress>
                    <label
                        v-if="submittEdit && !$v.brance.district.required"
                        class="invalid-th-address"
                    >กรุณากรอกอำเภอ/เขต (ภาษาไทย)</label>
                </div>
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> ตำบล/แขวง (ภาษาไทย)
                    </label>
                    <AutocompletesAddress
                        :queryInput="brance.state" 
                        :adsTypes="'sub-district'"
                        placeHolder="ตำบล/แขวง (ภาษาไทย)"
                        :class="{ 'is-invalid': submittEdit && $v.brance.state.$error }"
                        @input="brance.state = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'brance' )">
                    </AutocompletesAddress>
                    <label
                        v-if="submittEdit && !$v.brance.state.required"
                        class="invalid-th-address"
                    >กรุณากรอกตำบล/แขวง (ภาษาไทย)</label>
                </div>
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ที่อยู่ (ภาษาไทย)
                    </label>
                    <b-form-textarea
                        v-model="brance.address"
                        class="form-control"
                        placeholder="ที่อยู่ (ภาษาไทย)"
                        :class="{ 'is-invalid': submittEdit && $v.brance.address.$error }"
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                    <label
                        v-if="submittEdit && !$v.brance.address.required"
                        class="invalid-feedback"
                    >กรุณากรอกที่อยู่ (ภาษาไทย)</label>
                </div>
            </div>
            <div class="col-lg-6">
                <h6 class="heading-small text-muted mb-4">ที่อยู่ร้านภาษาอังกฤษ</h6>
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> รหัสไปรษณีย์
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="รหัสไปรษณีย์"
                        :class="{ 'is-invalid': submittEdit && $v.brance.postcodeEng.$error }"
                        v-model="brance.postcodeEng"
                    />
                    <!-- vuelidate -->
                    <label
                    v-if="submittEdit && !$v.brance.postcodeEng.required"
                    class="invalid-th-address"
                    >กรุณากรอกรหัสไปรษณีย์</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submittEdit && !$v.brance.postcodeEng.minLength"
                    >กรุณากรอก"รหัสไปรษณีย์" {{$v.brance.postcodeEng.$params.minLength.min}} หลัก</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submittEdit && !$v.brance.postcodeEng.maxLength"
                    >กรุณากรอก"รหัสไปรษณีย์" {{$v.brance.postcodeEng.$params.maxLength.max}} หลัก</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submittEdit && !$v.brance.postcodeEng.numeric"
                    >กรุณากรอกเฉพาะตัวเลข</label>
                </div>
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> จังหวัด (ภาษาอังกฤษ)
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="จังหวัด (ภาษาอังกฤษ)"
                        :class="{ 'is-invalid': submittEdit && $v.brance.provinceEng.$error }"
                        @input="brance.provinceEng = swapText(brance.provinceEng)"
                        v-model="brance.provinceEng"
                    />
                    <label
                        v-if="submittEdit && !$v.brance.provinceEng.required"
                        class="invalid-th-address"
                    >กรุณากรอกจังหวัด (ภาษาอังกฤษ)</label>
                </div>
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> อำเภอ/เขต (ภาษาอังกฤษ)
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="อำเภอ/เขต (ภาษาอังกฤษ)"
                        :class="{ 'is-invalid': submittEdit && $v.brance.districtEng.$error }"
                        @input="brance.districtEng = swapText(brance.districtEng)"
                        v-model="brance.districtEng"
                    />
                    <label
                        v-if="submittEdit && !$v.brance.districtEng.required"
                        class="invalid-th-address"
                    >กรุณากรอกอำเภอ/เขต (ภาษาอังกฤษ)</label>
                </div>
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> ตำบล/แขวง (ภาษาอังกฤษ)
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ตำบล/แขวง (ภาษาอังกฤษ)"
                        :class="{ 'is-invalid': submittEdit && $v.brance.stateEng.$error }"
                        @input="brance.stateEng = swapText(brance.stateEng)"
                        v-model="brance.stateEng"
                    />
                    <label
                        v-if="submittEdit && !$v.brance.stateEng.required"
                        class="invalid-th-address"
                    >กรุณากรอกตำบล/แขวง (ภาษาอังกฤษ)</label>
                </div>
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ที่อยู่ (ภาษาอังกฤษ)
                    </label>
                    <b-form-textarea
                        v-model="brance.addressEng"
                        @input="brance.addressEng = swapText(brance.addressEng)"
                        class="form-control"
                        placeholder="ที่อยู่ (ภาษาอังกฤษ)"
                        :class="{ 'is-invalid': submittEdit && $v.brance.addressEng.$error }"
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                    <label
                        v-if="submittEdit && !$v.brance.addressEng.required"
                        class="invalid-feedback"
                    >กรุณากรอกที่อยู่ (ภาษาอังกฤษ)</label>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ตำแหน่งที่ตั้งบนแผนที่  
                        <i class="fas fa-exclamation-circle fa-xs text-muted pr-2" style="cursor: pointer;" 
                            v-b-tooltip title="คลิกและลากหมุดไปยังตำแหน่งที่ตั้งร้านของคุณ">
                        </i>
                        <b-button variant="light" size="sm" @click="autoSearchLocationShop()" v-if="$USER_LOGIN.get().isAdmin">ค้นหาตำแหน่งที่ตั้งร้านตามข้อมูลที่อยู่ร้าน</b-button>
                        <label
                        class="invalid-th-address"
                        v-if="submittEdit && !$v.brance.latitudeShop.required && !$v.brance.longitudeShop.required"
                        >กรุณาระบุตำแหน่งที่ตั้งบนแผนที่</label>
                    </label>
                    <div>
                        <span>{{contentAddress}}</span>
                    </div>
                    <gmap-map
                        v-if="$USER_LOGIN.get().isAdmin"
                        ref="gmap"
                        :center="center"
                        :zoom="12"
                        :options="{
                            disableDoubleClickZoom: false,
                            mapTypeControl: false,
                            streetViewControl: false,
                            fullscreenControl: false,
                        }"
                        style="width:100%;  height: 400px;"
                        @click="updateLocation($event)"
                    >
                        <gmap-marker
                            :position="{
                                lat:(brance.latitudeShop != '') ? brance.latitudeShop : 0,
                                lng:(brance.longitudeShop != '') ? brance.longitudeShop : 0
                            }"
                            @dragend="updateLocation"
                            :clickable="true"
                            :draggable="true"
                            :icon="icon"
                            :options="{
                                crossOnDrag: false
                            }"
                        ></gmap-marker>
                    </gmap-map>
                    <b-input-group class="mt-3" v-else>
                        <b-form-input v-model="brance.linkGoogleMap" ref="linkMap" disabled></b-form-input>
                            <b-input-group-append>
                                <b-button variant="info" @click="copyLink()">Copy link</b-button>
                            </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> สถานที่ตั้งร้านของคุณอยู่ใกล้บริเวณไหน
                    </label>
                    <!-- <label>
                        {{brance.locationNear}}
                    </label> -->
                    <div class="row" v-for="( near , index ) in optionsLocationNear" :key="near.name">
                        <div class="col-lg-4">
                            <b-form-group>
                                <b-form-checkbox
                                    v-model="brance.locationNear"
                                    @change="clearInputLocationNear(near.key , index)"
                                    class="m-2"
                                    :state="($v.brance.locationNear.$error) ? false : null"
                                    :value="near.item"   
                                >
                                    {{near.name}}
                                </b-form-checkbox>
                            </b-form-group>
                        </div>
                        <div class="col-lg-8">
                            <input
                                type="text"
                                class="form-control"
                                :class="{ 'is-invalid': submittEdit && $v.brance[near.key].$error }"
                                :placeholder="(near.key == 'other') ? 'ประเภทสถานที่':`ชื่อ${near.name}`"
                                :disabled="disableLocation(near.key)"
                                :ref="near.key"
                                @input="mapInputLocationNear(near.key , index , $event.target.value)"
                                
                            />
                            <label
                                v-if="submittEdit && !$v.brance[near.key].required"
                                class="invalid-feedback d-block"
                            >กรุณากรอก{{(near.key == 'other') ? 'ประเภทสถานที่':`ชื่อ${near.name}`}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-4">วันและเวลาเปิดทำการ</h6>
        <div class="row">
             <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ระบุวันและเวลาเปิดทำการ
                        <label
                        class="invalid-th-address"
                        v-if="!$v.brance.closedDay.minLength"
                         >กรุณาระบุวันและเวลาเปิดทำการอย่างน้อย {{$v.brance.closedDay.$params.minLength.min}} วัน</label>
                    </label>
                    
                    <!-- <label>
                        {{brance.closedDay}}
                    </label> -->
                    <div class="row switch-brance" v-for="( day , index ) in optionsClosedDay" :key="day.name">
                        <div class="col-lg-5"> 
                            <b-form-group>
                                <b-form-checkbox
                                    v-model="brance.closedDay"
                                    @change="clearInputClosedDay(day.key , index)"
                                    class="m-2"
                                    :value="day.item"
                                    switch
                                    size="lg"
                                    :state="($v.brance.closedDay.$error) ? false : null"
                                >
                                    {{day.name}}
                                </b-form-checkbox>
                            </b-form-group>
                        </div>
                        <div class="col-lg-7">
                            <div class="d-flex">
                                <label class="text-muted d-flex align-items-center">เปิด</label>
                                <div class="col-lg-6 content--">
                                    <vue-timepicker 
                                        manual-input
                                        :input-class="['form-control' ,{ 'is-invalid': submittEdit && $v.brance[day.key+'Open'].$error }]"
                                        input-width="8em"
                                        :ref="day.key+'open'"
                                        :disabled="disableClosedDay(day.key)"
                                        v-model="open[day.key]"
                                        @input="mapInputClosedDayOpen(day.key , index , $event)"
                                    >
                                        <template v-slot:icon>
                                            <span class="text-dark">
                                                <i class="far fa-clock" style="pointer-events: auto;"></i>
                                            </span>
                                        </template>
                                    </vue-timepicker>
                                    <label
                                        v-if="submittEdit && !$v.brance[day.key+'Open'].required"
                                        class="invalid-feedback d-block"
                                    >กรุณากรอกเวลาเปิด</label>
                                </div>
                                <div class="col-lg-6">
                                    <vue-timepicker 
                                        manual-input
                                        :input-class="['form-control' ,{ 'is-invalid': submittEdit && $v.brance[day.key+'Close'].$error }]"
                                        input-width="8em"
                                        :ref="day.key+'close'"
                                        :disabled="disableClosedDay(day.key)"
                                        v-model="close[day.key]"
                                        @input="mapInputClosedDayClose(day.key , index , $event)"
                                    >
                                        <template v-slot:icon>
                                            <span class="text-dark">
                                                <i class="far fa-clock" style="pointer-events: auto;"></i>
                                            </span>
                                        </template>
                                    </vue-timepicker>
                                    <label
                                        v-if="submittEdit && !$v.brance[day.key+'Close'].required"
                                        class="invalid-feedback d-block"
                                    >กรุณากรอกเวลาปิด</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="$USER_LOGIN.get().isAdmin">
            <hr class="my-4" />
            <div class="mt-4 w-100 text-right">
                <b-button variant="secondary" @click="resetForm()">กรอกใหม่</b-button>
                <b-button type="submit" variant="info">บันทึก</b-button>
            </div>
        </template>
    </form>
</template>

<script>
import AutocompletesAddress from '@/components/Autocomplete/AddressTH/AutocompleteAddressTH'
import {
  required,
  minLength,
  maxLength,
  numeric,
  requiredIf
} from "vuelidate/lib/validators"
import validatePop from "@/plugins/validatePop.js"
import BranceTax from "./BranceTax.vue"
import swapLang from "../../../plugins/swapLang.js"
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
import { serviceAreaBrance }  from "@/plugins/formatForBrance.js";
import configPOPTheme from '@/config/POPTheme'
export default {
    name:"BranceUpgrade",
    components:{
        AutocompletesAddress,
        BranceTax
    },
    props: {
        submittEdit: Boolean,
        brance: Object,
        additional_service: Object,
        lazadaValidation: Object,
        flashValidation: Object
    },
    validations(){
      return this.rule
    },
    data(){
        return {
            customTheme: configPOPTheme,
            serviceAreaBrance:serviceAreaBrance,
            natureBusiness: [
                "ร้านขายของชำ",
                "ร้านกาแฟ",
                "ร้านอาหาร",
                "ร้านขายยา",
                "อื่นๆ"
            ],
            packageShop:[
                { value: "POP", text: (this.$THEME.packagePrefix) ? this.$THEME.packagePrefix['POP']: 'POP'},
                { value: "POPPLUS", text: (this.$THEME.packagePrefix) ? this.$THEME.packagePrefix['POPPLUS']: 'POPPLUS' },
                { value: "POPSHOP", text: (this.$THEME.packagePrefix) ? this.$THEME.packagePrefix['POPSHOP']: 'POPSHOP' }
            ],
            conditionArea:[
                { value: "0.5", text: "500 เมตร"},
                { value: "1.00", text: "1 กิโลเมตร" },
                { value: "2.00", text: "2 กิโลเมตร" },
                { value: "3.00", text: "3 กิโลเมตร" },
                { value: "4.00", text: "4 กิโลเมตร" },
                { value: "5.00", text: "5 กิโลเมตร" },
            ],
            typeCod:[
                { value: "1", text: "ใช้งาน" },
                { value: "0", text: "ไม่ใช้งาน" },
            ],
            detailPackage: configPOPTheme.customShopPackage || [
                { value: "TRIAL", text: "ทดลองใช้ 7 วัน"},
                { value: "1", text: "1 เดือน" },
                { value: "3", text: "3 เดือน" },
                { value: "6", text: "6 เดือน" },
                { value: "12", text: "12 เดือน" }
            ],
            center: {
                lat: 13.7303559,
                lng: 100.5363907
            },
            icon: {
                url: require("../../../assets/images/home.svg"),
                size: { width: 50, height: 50, f: "px", b: "px" },
                scaledSize: { width: 50, height: 50, f: "px", b: "px" }
            },
            contentAddress:"",
            open:{
                monday:'',
                tuesday:'',
                wednesday:'',
                thursday:'',
                friday:'',
                saturday:'',
                sunday:'',
                holidays:'',
            },
            close:{
                monday:'',
                tuesday:'',
                wednesday:'',
                thursday:'',
                friday:'',
                saturday:'',
                sunday:'',
                holidays:'',
            }
            
        }
    },
    mounted() {
        if(this.$USER_LOGIN.get().isShippop) {
            this.callPackageTheme()  
        }
    },
    methods:{
        enableAdditionalService(serviceKey) {
            if (
                this.additional_service && 
                this.additional_service.DROPOFF && 
                this.additional_service.DROPOFF[serviceKey]
            ) {
                return this.additional_service.DROPOFF[serviceKey].status
            } else {
                return false;
            }
        },
        async callPackageTheme () {
            const uri = '/package/theme'
            const header = {
                headers: {
                Token: localStorage.getItem("access_token")
                }
            }
            this.$http.get( this.$API_URL + uri, header).then((res)=> {
                const dataInArray = res.data.data
                this.packageShop = []
                dataInArray.map((val) => {
                    this.packageShop.push({value: val.id, text: val.name ? val.name : val.key})
                })
            })
        },
        createOrUpdateUpgrade(){       
            this.$emit('update:submittEdit', true);
            this.$v.brance.$touch();
            //this.$refs.branceTax.$v.vatShop.$touch();
            if (this.$v.brance.$invalid ) {//||  this.$refs.branceTax.$v.vatShop.$invalid ) {
                return false
            }
            
            if(this.brance.natureBusiness == 'อื่นๆ'){
                this.brance.natureBusiness = this.brance.natureBusinessOther
            }
            this.$emit('handleLoader');
            this.$http
                .post(
                this.$API_URL + "/shop/shop/detail",
                {
                    type: "brance",
                    name: this.brance.branceName,
                    name_eng: this.brance.branceNameEng,
                    tel: this.brance.branceTel,
                    company_name: this.brance.companyName,
                    nature_business: this.brance.natureBusiness,
                    address: this.brance.address,
                    state: this.brance.state,
                    district: this.brance.district,
                    province: this.brance.province,
                    postcode: this.brance.postcode,
                    address_eng: this.brance.addressEng,
                    state_eng: this.brance.stateEng,
                    district_eng: this.brance.districtEng,
                    province_eng: this.brance.provinceEng,
                    postcode_eng: this.brance.postcodeEng,
                    latitude_shop: this.brance.latitudeShop,
                    longitude_shop: this.brance.longitudeShop,
                    location_near: this.brance.locationNear,
                    closed_day: this.brance.closedDay,
                    vat: this.brance.vatShop.vat,
                    vat_courier: this.brance.vatShop.vatCourier,
                    tax_address: this.brance.vatShop.address,
                    tax_state: this.brance.vatShop.state,
                    tax_district: this.brance.vatShop.district,
                    tax_province: this.brance.vatShop.province,
                    tax_postcode: this.brance.vatShop.postcode,
                    tax_tel: this.brance.vatShop.tel,
                    tax_email: this.brance.vatShop.email,
                    tax_id: this.brance.vatShop.tax
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                }
                )
                .then(res => {
                    let checkError = validatePop( res )
                    this.$emit('handleLoader');
                    if( !checkError.status ){
                        showErrorModal( checkError.msg )
                        return false
                    }
                    showSuccessModal('บันทึกข้อมูลร้านสำเร็จ')
                })
        },
        onSubmitAddress( ads , objKey ){
            Object.keys(this[objKey]).forEach(key=>{
                if( ads[key] ){
                    this[objKey][key] = ads[key]
                }else if( key == 'state' ){
                    this[objKey]['state'] = ads['sub-district']
                }
                else{
                    this[objKey][key] = this[objKey][key]
                }
            })
        },
        swapText(text){
            let swap = text.split('')
            let swapText = '';
            swap.forEach(value =>{
                if(swapLang[value] && !['/','-','.',','].includes(value)){
                    swapText += swapLang[value]
                }else{
                    swapText += value
                }
            });
            return swapText;
        },
        clearInputClosedDay(key , index){
            this.optionsClosedDay[index].item[key] = {open:'',close:''}
            this.$refs[key+'open'][0].value = "";
            this.$refs[key+'close'][0].value = "";
        },
        clearInputLocationNear(key , index){
            this.optionsLocationNear[index].item[key] = ''
            this.$refs[key][0].value = "";
        },
        mapInputLocationNear( key , index , value ){
            let i = this.brance.locationNear.findIndex(location => {
                return Object.keys(location) == key
            });
            if( i > -1 ){
                this.brance.locationNear[i][key] = value  
            }
            this.optionsLocationNear[index].item[key] = value  
        },
        mapLocationNear(key){
            let index = this.optionsLocationNear.findIndex(location => {
                return location.key == key
            });
            if( this.optionsLocationNear[index].item[key] == '' ){
                return true;
            }
            return false;
        },
        mapInputClosedDayOpen( key , index , value){
            let i = this.brance.closedDay.findIndex(day => {
                return Object.keys(day) == key
            });
            if( i > -1 ){
                this.brance.closedDay[i][key].open = value  
            }
            this.optionsClosedDay[index].item[key].open = value
        },
        mapInputClosedDayClose( key , index , value){
            let i = this.brance.closedDay.findIndex(day => {
                return Object.keys(day) == key
            });
            if( i > -1 ){
                this.brance.closedDay[i][key].close = value  
            }
            this.optionsClosedDay[index].item[key].close = value
        },
        mapClosedDay(type , key){
            let index = this.optionsClosedDay.findIndex(day => {
                return day.key == key
            });
            if( type == 'open' && this.optionsClosedDay[index].item[key].open == '' ){
                return true;
            }
            if( type == 'close' && this.optionsClosedDay[index].item[key].close == ''){
                return true;
            }
            return false;
        },
        disableLocation(key){
            return !this.brance.locationNear.some(item => Object.keys(item) == key) 
        },
        disableClosedDay(key){
            return !this.brance.closedDay.some(item => Object.keys(item) == key) 
        },
        updateLocation(location) {
            this.brance.latitudeShop = location.latLng.lat();
            this.brance.longitudeShop = location.latLng.lng();
            this.searchLocation( "", {
                lat: this.brance.latitudeShop,
                lng: this.brance.longitudeShop
            } ) 
        },
        autoSearchLocationShop(){
            let res = false;
            let data = {};
            let address = '';

            Object.keys(this.brance).forEach(key => {
                if(['address','state','district','province','postcode'].includes(key)){
                    data[key] = this.brance[key]
                }
            });
            res = Object.values(data).every(val => (val != '' || val.length > 0));
            if(res){
                address = [this.brance.address,this.brance.state,this.brance.district,this.brance.province,this.brance.postcode].join(' ');
                this.searchLocation(address , {
                    lat: 0,
                    lng: 0
                })
            }
        },
        searchLocation(address,latLng) {
            let geocoder = new google.maps.Geocoder();
            geocoder.geocode( { address: address, location: latLng }, (results, status) => {
                if (status === "OK") {
                    if (latLng.lat && latLng.lng > 0) {
                        this.contentAddress = results[0].formatted_address; 
                    }
                    if (address) {
                        this.brance.latitudeShop = results[0].geometry.location.lat();
                        this.brance.longitudeShop = results[0].geometry.location.lng();
                        this.contentAddress = address;
                        this.center.lat = this.brance.latitudeShop
                        this.center.lng = this.brance.longitudeShop
                    }
                }
            });
        },
        copyLink(){
            let Url = this.$refs.linkMap;
            Url.innerHTML = window.location.href;
            Url.select();
            document.execCommand("copy");
        },
        resetForm(){
            Object.keys(this.brance).forEach(key => {
                if(!['apiKey','contractDate','package','serviceAreaCondition','selectedCod','selectTrial','member','dateExp'].includes(key)){
                    if(key == 'closedDay'){
                        this.brance[key].forEach( (item , index) =>{
                            this.clearInputClosedDay(Object.keys(item) , index);
                        })
                        this.brance[key] = [];
                    }else if(key == 'locationNear'){
                        this.brance[key].forEach( (item , index) =>{
                            this.clearInputLocationNear(Object.keys(item) , index);
                        })
                        this.brance[key] = [];
                    }else if( ['latitudeShop','longitudeShop'].includes(key)){
                        this.brance[key] = 0;
                    }
                    else{
                        this.brance[key] = '';
                    }
                }
            });
        }
    },
    computed:{
        optionsLocationNear(){
            return[
                { item: {dorm:''}, name: 'หอพัก', key: 'dorm' },
                { item: {village:''}, name: 'หมู่บ้าน', key: 'village' },
                { item: {market:''}, name: 'ตลาด', key: 'market' },
                { item: {condo:''}, name: 'คอนโด', key: 'condo' },
                { item: {building:''}, name: 'อาคารพาณิชย์', key: 'building' },
                { item: {road:''}, name: 'ติดถนนใหญ่', key: 'road' },
                { item: {gas:''}, name: 'ปั๊มน้ำมัน', key: 'gas' },
                { item: {mall:''}, name: 'ในห้างสรรพสินค้า', key: 'mall' },
                { item: {other:''}, name: 'อื่นๆ โปรดระบุ', key: 'other' },
            ]
        },
        optionsClosedDay(){
            return[
                { item: {monday:{open:'',close:''}}, name: 'จันทร์', key: 'monday'},
                { item: {tuesday:{open:'',close:''}}, name: 'อังคาร', key: 'tuesday' },
                { item: {wednesday:{open:'',close:''}}, name: 'พุธ', key: 'wednesday' },
                { item: {thursday:{open:'',close:''}}, name: 'พฤหัสบดี', key: 'thursday' },
                { item: {friday:{open:'',close:''}}, name: 'ศุกร์', key: 'friday' },
                { item: {saturday:{open:'',close:''}}, name: 'เสาร์', key: 'saturday' },
                { item: {sunday:{open:'',close:''}}, name: 'อาทิตย์', key: 'sunday' },
                { item: {holidays:{open:'',close:''}}, name: 'วันหยุดนักขัตฤกษ์', key: 'holidays' },
            ]
        },
        rule(){
            let res = {
                brance:{
                    branceName: { required, minLength: minLength(2) },
                    branceNameEng: { required },
                    branceTel: { required, minLength: minLength(9) },
                    natureBusiness: { required },
                    natureBusinessOther: { required: requiredIf(function (business) {
                        return business.natureBusiness == 'อื่นๆ'
                    })},
                    address: { required, minLength: minLength(5) },
                    state: { required },
                    district: { required },
                    province: { required },
                    postcode: { required, numeric, minLength: minLength(4), maxLength: maxLength(5) },
                    addressEng: { required },
                    stateEng: { required },
                    districtEng: { required },
                    provinceEng: { required },
                    postcodeEng: { required, numeric, minLength: minLength(4), maxLength: maxLength(5) }, 
                    locationNear: { required },  
                    latitudeShop: { required },
                    longitudeShop: { required },
                    closedDay: { required, minLength: minLength(4) },
                }
            }
            this.optionsLocationNear.forEach( location => {
                res.brance[location.key] = { required: requiredIf(function () {
                    return !this.disableLocation(location.key) && this.mapLocationNear(location.key)
                })}
            }) 
            this.optionsClosedDay.forEach( day => {
                res.brance[day.key+'Open'] = { required: requiredIf(function () {
                    return !this.disableClosedDay(day.key) && this.mapClosedDay('open',day.key)
                }) }
                res.brance[day.key+'Close'] = { required: requiredIf(function () {
                    return !this.disableClosedDay(day.key) && this.mapClosedDay('close',day.key)
                }) }
            })

            return res
        }
    }
}
</script>

<style>
.is-invalid{
    border-color:red !important;
}
</style>